import { render, staticRenderFns } from "./SRDA31s1p1SupportingDocuments.view.vue?vue&type=template&id=1bc49d83&"
import script from "./SRDA31s1p1SupportingDocuments.view.vue?vue&type=script&lang=js&"
export * from "./SRDA31s1p1SupportingDocuments.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc49d83')) {
      api.createRecord('1bc49d83', component.options)
    } else {
      api.reload('1bc49d83', component.options)
    }
    module.hot.accept("./SRDA31s1p1SupportingDocuments.view.vue?vue&type=template&id=1bc49d83&", function () {
      api.rerender('1bc49d83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/update/partials/supplier-requirements/SRDA31s1p1SupportingDocuments.view.vue"
export default component.exports